import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconVpCoin({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M.17.2h21.644v21.346H.17z" />
				<path id="c" d="M.174.1h10.822v10.673H.174z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<g transform="translate(1.173 1.358)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.992 21.546C5.016 21.546.17 16.767.17 10.873S5.016.2 10.992.2c5.977 0 10.823 4.778 10.823 10.673"
						mask="url(#b)"
					/>
				</g>
				<g transform="translate(11.991 12.13)">
					<mask id="d" fill="#fff">
						<use xlinkHref="#c" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.996.1c0 5.895-4.845 10.673-10.822 10.673"
						mask="url(#d)"
					/>
				</g>
				<path
					fill="#FFF"
					d="M22.096 11.352c0 5.894-4.846 10.673-10.822 10.673-5.977 0-10.822-4.779-10.822-10.673S5.297.679 11.274.679s10.822 4.778 10.822 10.673"
				/>
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="M15.285 9.045v1.03H7.262v-1.03z"
				/>
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="m8.448 6.585 2.986 8.632 2.568-8.61.992.293-3.487 11.692L7.469 6.921z"
				/>
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="M14.62 11.732v1.03H7.957v-1.03z"
				/>
				<path
					fill="#CD0400"
					d="M11.82 3.32a8.9 8.9 0 0 1 6.928 3.288 8.89 8.89 0 0 0-7.518-4.109c-4.898 0-8.868 3.916-8.868 8.746 0 2.065.728 3.962 1.941 5.458a8.6 8.6 0 0 1-1.35-4.637c0-4.83 3.97-8.746 8.868-8.746"
				/>
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="M11.9 1.06v1h-.82v-1zm-2.002.138.373.972-.626.051-.374-.971zm-1.928.447.553.927-.448.101-.552-.926zm-1.744.742.663.854-.338.149-.662-.855zM4.678 3.401l.74.799-.26.201-.74-.799zM3.353 4.657l.803.737-.198.263-.802-.737zm-1.066 1.46.866.658-.147.342-.866-.66zm-.785 1.618.94.55-.1.45-.94-.549zm-.488 1.728.985.372-.051.628-.985-.37zm.824 1.787v.82h-1v-.82zm.126 1.616.05.63-.984.37-.051-.628zm.408 1.572.1.45-.94.55-.1-.451zm.679 1.477.147.342-.866.658-.147-.341zm.965 1.339.198.263-.802.737-.198-.263zm1.212 1.16.26.2-.74.8-.26-.202zm1.402.944.337.149-.661.854-.339-.148zm1.53.702.448.102-.552.927-.448-.102zm1.574.437.627.052-.374.972-.626-.052zm2.257.16v1h-.82v-1zm1.447-.175.374.971-.627.052-.373-.971zm1.415-.452.552.927-.448.101-.552-.927zm1.388-.716.662.854-.338.148-.662-.854zm1.279-.958.74.799-.259.201-.74-.799zm1.114-1.171.802.737-.197.263-.803-.737zm.907-1.348.866.66-.146.34-.867-.658zm.665-1.483.94.549-.1.45-.94-.548zm.394-1.576.984.372-.05.628-.985-.371zm1.11-1.618v.82h-1v-.82zm-.192-1.785.05.629-.984.371-.051-.629zm-.504-1.724.1.451-.939.549-.1-.451zm-.799-1.611.147.34-.866.66-.147-.342zM19.18 4.588l.198.264-.802.736-.198-.263zm-1.249-1.244.26.2-.74.8-.26-.202zm-1.445-1.002.338.148-.662.855-.338-.149zm-1.615-.728.449.102-.552.927-.448-.102zm-1.776-.432.627.052-.373.972-.627-.052z"
				/>
			</g>
		</svg>
	);
}
